import type { ComponentProps, ReactNode } from 'react';

import { cn } from '../cn';

export const AlertLabelPropsSize = ['sm'] as const;
export const AlertLabelPropsType = ['warning', 'error'] as const;

type AlertLabelProps = ComponentProps<'div'> & {
  type: (typeof AlertLabelPropsType)[number];
  size?: (typeof AlertLabelPropsSize)[number];
  icon?: ReactNode;
};

export default function AlertLabel({ children, type, className, size, icon, ...props }: AlertLabelProps) {
  return (
    <div
      className={cn(
        'flex items-center [&>svg]:shrink-0',
        {
          'gap-3 rounded-lg px-3 py-3 text-base font-medium': size == null,
          'gap-2 rounded-md p-2 text-xs font-black': size === 'sm',
        },
        {
          'border border-indigo-500 bg-indigo-50 text-indigo-900 dark:border-indigo-800 dark:bg-indigo-950 dark:text-indigo-100':
            type === 'warning',
          'bg-fair-pink-50 text-fair-pink-700 dark:bg-fair-pink-700 dark:text-fair-pink-50': type === 'error',
        },
        className,
      )}
      {...props}>
      <div className="size-5 shrink-0 [&>svg]:size-full">{icon}</div>
      {children}
    </div>
  );
}
